import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("voyacar_cookie_consent")) setShow(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem("voyacar_cookie_consent", value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-40 p-4" data-testid="cookie-consent">
      <div className="max-w-4xl mx-auto bg-white border border-neutral-200 shadow-xl rounded-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="h-6 w-6 text-[#A11016] shrink-0 mt-0.5" />
          <p className="text-sm text-neutral-600">
            Web sitemizde deneyiminizi geliştirmek için çerezler kullanıyoruz. Detaylar için{" "}
            <Link to="/cerez-politikasi" className="text-[#A11016] underline underline-offset-2">Çerez Politikamızı</Link> inceleyebilirsiniz.
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" onClick={() => decide("rejected")} data-testid="cookie-reject-button">Reddet</Button>
          <Button className="bg-[#A11016] hover:bg-[#820D12] text-white" onClick={() => decide("accepted")} data-testid="cookie-accept-button">Kabul Et</Button>
        </div>
      </div>
    </div>
  );
}
